import * as React                                    from "react"
import { CardModal, CardModalType, CardModalNotOkButton } from "../../modal"

export default class AddWordModal
extends React.Component<AddWordModalProps> {
	render() {
		const onClickAddWordModalCloseButton  = this.props.onClickCloseButton
		const onClickAddWordModalFooterButton = this.props.onClickFooterButton
		const onSubmitAddWordModal            = this.props.onSubmit
		const submitting                      = this.props.submitting
		const errors                          = this.props.errors

		return (
			<CardModal active
			           loading={submitting}
			           onClickCloseButton={onClickAddWordModalCloseButton}
			           onClickFooterButton={onClickAddWordModalFooterButton}
			           onSubmit={onSubmitAddWordModal}
			           title="Ajouter un mot au glossaire"
			           type={CardModalType.ValidCancel}>
				<div className="columns is-mobile">
					<div className="column field">
						<label className="label" htmlFor={Names.TERM}>Terme</label>
						<p className={`control has-icons-left ${submitting ? "is-loading" : ""}`}>
							<input className={`input ${errors.term ? "is-danger": ""}`}
							       disabled={submitting}
							       id={Names.TERM}
							       name={Names.TERM}
							       min={0}
							       required
							       type="text" />
							<span className="icon is-left">
								<i className="fas fa-comment-alt" />
							</span>
						</p>
						{errors && errors.term && <p className="help is-danger">{errors.term}</p>}
						<label className="label" htmlFor={Names.DEFINITION}>Définition</label>
						<p className={`control has-icons-left ${submitting ? "is-loading" : ""}`}>
							<textarea className={`textarea ${errors.definition ? "is-danger": ""}`}
									disabled={submitting}
									id={Names.DEFINITION}
									name={Names.DEFINITION}
									required/>
							<span className="icon is-left">
								<i className="fas fa-pen" />
							</span>
						</p>
						{errors && errors.definition && <p className="help is-danger">{errors.definition}</p>}
					</div>
				</div>
			</CardModal>
		)
	}
}

export namespace Names {
	export const TERM       = "term"
	export const DEFINITION = "definition"
	export const ID         = "id"
}

export interface AddWordModalProps {
	errors?            : AddWordErrors
	onClickCloseButton : (event: React.SyntheticEvent<Element>) => void
	onClickFooterButton: (button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>) => void
	onSubmit           : (event: React.SyntheticEvent<Element>) => void
	submitting         : boolean
}

export interface AddWordErrors {
	term?      : string
	definition?: string
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/add-word-modal.tsx